const pagesStarlinksEn = {
  overview: {
    dataPool: {
      title: "Data pool",
      dailyAverage: "Daily average",
      estimatedOn: "Estimated on",
    },
    geolocation: {
      title: "Geolocation",
      total: "Total",
      status: {
        alert: "Alert",
        notDetected: "Not detected",
        healthy: "Healthy",
      },
    },
    monthlyDataUsage: {
      title: "Monthly Data Usage",
      avg: "Avg.",
    },
    placement: {
      title: "Placement",
      fleet: "Fleet",
      place: "Place",
    },
    noData: "No data available",
  },
  list: {
    pageTitle: "Starlink",
    filterPlaceholder: "Filter by name...",
    filters: {},
    tabs: {
      ACTIVE: "Active",
      NOT_ACTIVE: "Inactive",
      ALL: "All",
      userTerminals: "User Terminals",
      overview: "Overview",
      alerts: "Alerts",
      marketplace: "Marketplace",
      billingAndCost: "Billing & Cost",
      operationActivity: "Operation Activity",
    },
  },
  detail: {
    toast: {
      saveSuccess: "Saved successfully",
    },
    navigation: {
      terminalId: "Terminal id",
      userTerminalIdInfo: "User terminal ID Info",
      placement: "Placement",
      routers: "Routers",
      networks: "Networks",
    },
    tabs: {
      overview: "Overview",
      detail: "Detail",
      networks: "Networks",
      rulesAndPolicy: "Rules & Policy",
    },
    breadcrumbs: {
      starlinks: "Starlink",
      terminal: "Terminal",
    },
    lastUpdated: "Last updated",
    overview: {
      noData: "No data available",
      sections: {
        currentPerformance: "Current Performance",
        networkStatistics: "Network statistics",
      },
      timeRanges: {
        "1hr": "1 hr",
        "3hrs": "3 hrs",
        "24hrs": "24 hrs",
        "7days": "7 days",
        "30days": "30 days",
      },
      metrics: {
        downlinkThroughput: "Downlink throughput",
        uplinkThroughput: "Uplink throughput",
        latency: "Latency",
        pingLatency: "Ping latency",
        signalQuality: "Signal quality",
        obstruction: "Obstruction",
      },
      helpMessages: {
        downlink: "Download speed in Mbps",
        uplink: "Upload speed in Mbps",
        latency: "Round trip time to the Starlink POP",
        pingLoss:
          'Percentage of "pings" sent that did not get a response from the POP. You should not experience any effects while ping loss is less than 3%',
        signalQuality:
          "Signal Quality is an indication of Signal to Noise Ratio (SNR) which we represent as a percentage from 0% - 100%",
        obstruction:
          "Check to see where you may have obstructions causing intermittent service. Any obstruction level is bad for performance. If you see obstruction percentage greater than 0.2%, your install location or current surroundings is having a negative effect on performance. Anything more than 0.27% obstruction will cause enough outages for the end user to notice. In this case, please consider adjusting your install location or raising up your Starlinks to improve your performance. A Starlink should have a clear view above 20 degrees elevation, in ALL directions 360 degrees around the azimuth.",
      },
      chartCard: {
        average: "Avg.",
        vsYesterday: "vs yesterday",
        chartVisualization: "Chart visualization",
      },
    },
    sections: {
      userTerminalIdInfo: {
        title: "User Terminal ID Info",
        nickname: "Nickname",
        userTerminalId: "User terminal ID",
        kitSerialNumber: "Kit serial number",
        dishSerialNumber: "Dish serial number",
      },
      placement: {
        title: "Placement",
        changePlacement: "Change placement",
        placement: "Placement",
        address: "Address",
        currentGeolocation: "Current geolocation",
        mapPlaceholder: "Location information could not be retrieved",
      },
      routers: {
        title: "Routers",
        addRouter: "Add router",
        noData: "No routers found",
        tableHeaders: {
          router: "Router",
          starlinkRouterId: "Starlink Router ID",
          wifiSoftwareVersion: "Wi-Fi software version",
        },
      },
      networks: {
        title: "Networks",
        addNetwork: "Add network",
        removeNetwork: "Remove network",
        noData: "No networks registered",
        tableHeaders: {
          network: "Network",
          purpose: "Purpose",
          ipAddress: "IP Address",
        },
      },
    },
    dialogs: {
      addNetwork: {
        title: "Add network",
        fields: {
          network: {
            label: "Network",
            placeholder: "Select something...",
            selectPlaceholder: "Select",
            searchPlaceholder: "Search",
            error: "An error occurred",
          },
        },
        actions: {
          cancel: "Cancel",
          save: "Save",
        },
      },
      changePlacement: {
        title: "Change placement",
        fields: {
          from: "From",
          to: "To",
        },
        actions: {
          cancel: "Cancel",
          save: "Save",
        },
      },
    },
  },
  alerts: {
    pageTitle: "Alerts",
    filterPlaceholder: "Filter by name...",
    tabs: {
      ALL: "All",
      DISABLED: "Disabled",
      DATA_OVERAGE: "Data overage",
      PERFORMANCE_ISSUE: "Performance issue",
      UPDATE: "Update",
      ROUTER_ISSUE: "Router issue",
      OTHERS: "Others",
    },
    alertTypes: {
      Disabled: "Disabled",
      "Data overage": "Data overage",
      "Performance issue": "Performance issue",
      Update: "Update",
      "Router issue": "Router issue",
      Others: "Others",
    },
    alertTitles: {
      ethernetSlow10mbps: "Ethernet slow (10mbps)",
      ethernetSlow100mbps: "Ethernet (100mbps)",
      thermalThrottlingPowerSupply: "Thermal throttling of power supply",
      actuatorMotorStuck: "Actuator motor stuck",
      mastNotVertical: "Mast not vertical",
      noActiveServiceLine: "No active service line",
      tooFarFromServiceAddress: "Too far from service address",
      noServiceInOcean: "No service in ocean",
      invalidCountry: "Invalid country",
      movingWhileNotMobile: "Moving while not mobile",
      movingTooFast: "Moving too fast",
      powerDisconnectDetected: "Power disconnect detected",
      popChange: "PoP change",
      pendingSoftwareUpdateReboot: "Pending software update reboot",
      unableToAlign: "Unable to align",
      highTimeObstruction: "High time obstruction",
      thermalShutdown: "Thermal shutdown",
      thermalThrottling: "Thermal throttling",
      blockedCountry: "Blocked country",
      dataUsageExceededQuota: "Data usage exceeded quota",
      cellIsDisabled: "Cell is disabled",
      unlicensedCountry: "Unlicensed country",
      roamRestricted: "Roam restricted",
      unknownLocation: "Unknown location",
      accountDisabled: "Account disabled",
      highSkyObstruction: "High sky obstruction",
      unsupportedVersion: "Unsupported version",
      dataOverageRateLimited: "Data overage rate limited",
    },
    alertDescriptions: {
      ethernetSlow10mbps:
        "The ethernet link has auto negotiated to 10 Mbps. The Starlink device should auto negotiate to 1000 Mbps. There may be a cable or connection issue. Make sure the client device port is configured to 1000 Mbps auto-negotiation.",
      ethernetSlow100mbps:
        "The ethernet link has auto negotiated to 100 Mbps. The Starlink device should auto negotiate to 1000 Mbps. There may be a cable or connection issue. Make sure the client device port is configured to 1000 Mbps auto-negotiation.",
      thermalThrottlingPowerSupply:
        "The power supply is exceeding it's upper safety thermal threshold. As a result, the Starlink is throttling itself to reduce its power draw and let the power brick cool down.",
      actuatorMotorStuck:
        "For actuated Starlink devices, the actuator motor is jammed and is not able to align the Starlink antenna to the desired angle. This can cause reduced performance, or the Starlink may not be able to connect to the network if the tilt too far from nominal.",
      mastNotVertical:
        "For actuated Starlink devices, the Starlink alignment system is not able to align the Starlink antenna to the desired angle because the mast is greater than 30 degrees from vertical. This may cause poor performance, or the Starlink device may not be able to connect to the network unless corrected.",
      noActiveServiceLine:
        "The service line associated with the Starlink device is not active or has been cancelled. Check that the service line is active and the account is in good standing. Ensure that payment details are setup and no outstanding unpaid invoices have caused the service to be disabled.",
      tooFarFromServiceAddress:
        "The Starlink device has moved too far from the service location on the account. Update the service address to resume service.",
      noServiceInOcean:
        "The Starlink device has moved into ocean coverage and does not have mobile priority data available. Update service plans to a Mobile Priority plan with additional data, or opt-in for Mobile Priority Data if you are on a mobile plan and have exceeded the Mobile Priority Data limit.",
      invalidCountry:
        "The Starlink device has moved to a country where Starlink is either not enabled or the service plan is limited to a specific region. If Starlink coverage is enabled, opt-in for Mobile Priority Data or upgrade to a Mobile Global or Mobile Priority Service plan.",
      movingWhileNotMobile:
        "The Starlink device is moving at greater than 10 MPH (4.4. meters per second) and service has been disabled. Update the service plan to a Mobile Priority service plan. Or opt-in for Mobile Priority Data.",
      movingTooFast:
        "The Starlink device is moving faster than the configured policy allows and service has been disabled. Update the service plan to one which supports higher speeds.",
      powerDisconnectDetected:
        "The Starlink will report this alert when recovering from an unexpectedly power disconnect.",
      popChange:
        "The Starlink point of presence (PoP) has changed and as a result the Starlink will have a new IP address assigned for that region.",
      pendingSoftwareUpdateReboot:
        "The Starlink device has downloaded a software update and is scheduled to reboot at 3 AM local time +/- 30 minutes. Local time is based on the current physical location of the Starlink hardware. After this alert is triggered, a manual reboot will also update the software if a the scheduled time is inconvenient.",
      unableToAlign:
        "The Starlink device is installed in a location that it's not able to align the antenna to the desired angle. This may cause poor performance, or the Starlink device may not be able to connect to the network unless corrected. If the Starlink device has an actuator motor, physically inspect the Starlink install to ensure that the motor is functioning correctly by stowing and un-stowing the Starlink from the Starlink mobile app. If the Starlink device is a Flat mount un-actuated model, check that the Starlink is securely attached to a horizontal surface.",
      highTimeObstruction:
        "The Starlink device detected a high percentage of the time when the Starlink device was not able to make a connection to a satellite. The high time obstruction alert is an indicator of the time that Starlink was unable to successfully make a connection and the connection was dropped. This alert will be set if 0.27% of the time Starlink field of view is obstructed. Check that the Starlink is in an unobstructed location in all directions.",
      thermalShutdown:
        "The Starlink device has reached the maximum temperature threshold and has stopped service to cool down. Service will resume when the Starlink device reaches a nominal operating temperature. Starlink devices are designed to operation nominally when the ambient temperature is below 50 degrees Celcius. In extreme cases the Starlink will reboot in order to recover. Physically check that the Starlink device is installed in a location that is properly ventilated and not exposed to external heat sources, e.g. near an exhaust vent.",
      thermalThrottling:
        "The Starlink device has reached a high temperature threshold and is throttling performance to cool down. Performance will improve when the Starlink device reaches a nominal operating temperature. Starlink devices are designed to operation nominally when the ambient temperature is below 50 degrees Celcius. Physically check that the Starlink device is installed in a location that is properly ventilated and not exposed to external heat sources e.g. near an exhaust vent.",
      blockedCountry:
        "The Starlink device has moved to a country where Starlink is either not enabled or the service plan is limited to a specific region. If Starlink is coverage is enabled, upgrade to a Mobile Global or Mobile Priority Service plan. Or opt-in for Mobile Priority Data.",
      dataUsageExceededQuota:
        "The Starlink device has been disabled as data usage has execeeded the data quota. If Starlink coverage is enabled, upgrade your plan to a higher quota.",
      cellIsDisabled:
        "The Starlink device has moved to a cell that Starlink does not serve. The current cell will not get beams for service.",
      unlicensedCountry:
        "The Starlink device is in an unlicensed country and has been disabled. The Starlink's policy prohibits being served in unlicensed countries.",
      roamRestricted:
        "The Starlink device is being georestricted after roaming for too long in a country that is not the roaming terminal's home country. Restriction is not imposed if the user is in their home country.",
      unknownLocation:
        "The Starlink device cannot determine its location and cannot receive service.",
      accountDisabled:
        "The Starlink device will be disabled if the account it is on is also disabled. Please log in to this account to get more information on the restriction.",
      highSkyObstruction:
        "The Starlink device fires this alerts when its obstruction map is more than 0.5% obstructed.",
      unsupportedVersion:
        "The Starlink's software version is unsupported. This can happen if the Starlink has been offline for a while. Please submit a ticket if the issue persists.",
      dataOverageRateLimited:
        "Starlink is rate limited as it is out of priority data. Add more by topping up or enabling automatic top-up.",
    },
  },
};

export default pagesStarlinksEn;
